import React from "react";
import ImageWithLoader from "shared/ui/image";
import EmptyStateComponent from "shared/ui/empty";
import { useSearchParams } from "react-router-dom";

export default function CategoryCard({
  title,
  onAddClick,
  onEditClick,
  onDeleteClick,
  loading,
  categories = [],
  onSelect,
}) {
  const placeholders = Array(8).fill(null);

  const [searchParams] = useSearchParams();
  const catId = searchParams.get("cat");

  return (
    <div className="col-lg-6 col-md-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          {loading ? (
            <>
              {/* Title Placeholder */}
              <div className="placeholder-glow">
                <span
                  className="placeholder col-6"
                  style={{ height: "1.2em" }}
                ></span>
              </div>
              {/* Button Placeholder */}
              <div className="placeholder-glow">
                <span
                  className="placeholder col-3"
                  style={{ height: "1.8em" }}
                ></span>
              </div>
            </>
          ) : (
            <>
              <h5 className="mb-0">{title}</h5>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={onAddClick}
              >
                <i className="mdi mdi-plus me-1"></i> Нэмэх
              </button>
            </>
          )}
        </div>

        <div className="card-body pt-0">
          <div className="table-responsive mt-n2">
            {loading ? (
              <table className="table mb-0">
                <tbody>
                  {placeholders.map((_, idx) => (
                    <tr key={idx}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="placeholder-glow">
                            <span
                              className="placeholder rounded-circle"
                              style={{ width: 40, height: 40 }}
                            ></span>
                          </div>
                          <div className="ms-2 flex-grow-1">
                            <div className="placeholder-glow mb-1">
                              <span className="placeholder col-6"></span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="text-end">
                        <div className="placeholder-glow">
                          <span className="placeholder col-3 me-2"></span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : categories.length > 0 ? (
              <table className="table table-centered table-hover table-nowrap mb-0">
                <tbody>
                  {categories.map((category, index) => (
                    <tr
                      onClick={() => onSelect && onSelect(category)}
                      key={index}
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          String(category.id) === String(catId)
                            ? "#eef2f7"
                            : "transparent",
                      }}
                    >
                      <td>
                        <div className="d-flex align-items-center">
                          <ImageWithLoader
                            src={category.imageUrl || category.image}
                            alt={category.name}
                            width="40px"
                            height="40px"
                            className="rounded-circle"
                          />
                          <div
                            className="ms-2"
                            style={{
                              wordBreak: "break-word", // урт текстийг дараагийн мөрөнд оруулна
                              overflowWrap: "break-word",
                              maxWidth: "200px", // хүссэн өргөнөө тохируулах
                            }}
                          >
                            {category.name}
                          </div>
                        </div>
                      </td>
                      <td className="text-end">
                        <div
                          className="action-icon me-2"
                          onClick={() => onEditClick && onEditClick(category)}
                        >
                          <i className="mdi mdi-square-edit-outline"></i>
                        </div>
                        <div
                          className="action-icon me-2"
                          onClick={() =>
                            onDeleteClick && onDeleteClick(category)
                          }
                        >
                          <i className="mdi mdi-delete"></i>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <EmptyStateComponent title="Дэд ангилал байхгүй байна" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
